// @flow
import React, { useState } from 'react';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import { getId } from 'UI/utils';

import { useStyles } from './styles';

interface FPToggleButtonProps {
  options?: any;
  onChange: () => any;
}

const FPToggleButton = ({ options, onChange, initialValue, ...rest }: FPToggleButtonProps) => {
  const classes = useStyles();
  const [value, setValue] = useState(initialValue || options[0]?.value);

  const handleToggle = (event, newValue) => {
    if (newValue !== null) {
      setValue(newValue);
      onChange && onChange(newValue);
    }
  };

  return (
    <ToggleButtonGroup exclusive onChange={handleToggle} value={value} {...rest}>
      {options?.map(option => (
        <ToggleButton
          key={getId()}
          value={option.value}
          disabled={option.disabled}
          classes={classes}
        >
          {option?.icon && <span>{option.icon}</span>} {option.title}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

FPToggleButton.defaultProps = {
  options: null
};

export default FPToggleButton;
